import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import GLOBAL from 'jcolorglobal';
import CupoyRouter from "components/commons/router/CupoyRouter";
import CupoySrefView from "components/commons/router/CupoySrefView";
import TimeFormat from 'components/commons/TimeFormat';

class TurnkeyUploadLogListItem extends PureComponent {

    static propTypes = {
        item: PropTypes.object.isRequired,
    };

    // constructor(props) {

    //     super(props);
    // }

    render() {
        const {
            item,
        } = this.props;
        
        return (            
            <tr className="table-list-row">
                <td className="table-list-col link" style={{width: '100px'}}>
                    {item.srctype === GLOBAL.SRCTYPE.JCOLOR ?
                        <CupoySrefView
                            statename={CupoyRouter.STATES.INVOICE_INFO}
                            params={{
                                yearmonth: item.yearmonth,
                                istarttag: item.istarttag,
                                invoicenumber: item.invoicenumber,
                            }}
                        >
                            {item.istarttag}-{item.invoicenumber}
                        </CupoySrefView>
                        :
                        <span>{item.istarttag}-{item.invoicenumber}</span>
                    }
                </td>
                <td className="table-list-col" style={{width: '70px'}}>
                    {item.yearmonth}
                </td>
                <td className="table-list-col" style={{width: '80px'}}>
                    <TimeFormat
                        format="simpleFullTime"
                        time={item.createtime}
                    />
                </td>               
                <td className="table-list-col" style={{width: '140px'}}>
                    {item.xmlformat}
                </td>   
            </tr>
        );
    }
}

export default TurnkeyUploadLogListItem;



// WEBPACK FOOTER //
// ./src/components/turnkeyuploadlog/TurnkeyUploadLogListItem.jsx